// prettier-ignore-start
// must be first import
import { scan } from 'react-scan'
// prettier-ignore-end
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '~/app'
import { logVersionToConsole } from '~/shared/lib/version'

scan({
  enabled: true,
})

// Log version info to console
if (import.meta.env.MODE !== 'production' || import.meta.env.VITE_SHOW_VERSION) {
  logVersionToConsole()
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
